export const InformacionItem = [
  {
    "informacion_grupo":"Tecnologías de la Información",
    "informacion_array":[
      {  
        "informacion_item_nombre": "Repositorio Estatal de Información en Salud",
        "informacion_item_url": "https://ssh.gob.mx/seishgo/",
      },
      // {
      //   "informacion_item_nombre": "Fichas Técnicas",
      //   "informacion_item_url": "https://ft.ssh.gob.mx/login",
      // },
      // {
      //   "informacion_item_nombre": "Lineamientos",
      //   "informacion_item_url": "../contenido/informacion/Manual Espacio Promotor de la Alimentación Correcta y la AF_REV 210319.pdf",
      // },     
    ]
  },
  {
    "informacion_grupo":"Planeación y Evaluación",
    "informacion_array":[
      {
        "informacion_item_nombre": "Tablero Estratégico de Control de Indicadores",
        "informacion_item_url": "https://indicadores.hidalgo.gob.mx/", 
      }
    ]
  },
  {
    "informacion_grupo":"Marco Operativo SSH",
    "informacion_array":[
      {
        "informacion_item_nombre": "Marco Operativo de SSH",
        "informacion_item_url": "MarcoOpSsh",
      },
      // {
      //   "informacion_item_nombre": "Manual de Organización de Servicios de Salud de Hidalgo",
      //   "informacion_item_url": "../contenido/informacion/MANUAL DE ORGANIZACION SSH 2021.pdf",
      // },
      // {
      //   "informacion_item_nombre": "Manual de Procedimientos de Servicios de Salud de Hidalgo",
      //   "informacion_item_url": "../contenido/informacion/MANUAL DE PROCEDIMIENTOS SSH 2021.pdf",
      // },
    ]
  },
  {
    "informacion_grupo":"Marco Operativo SESA",
    "informacion_array":[
      {
        "informacion_item_nombre": "Marco Operativo de SESA",
        "informacion_item_url": "MarcoOpSesa/MarcoOpSesa", 
      },
      // {
      //   "informacion_item_nombre": "Manual de Organización de la Secretaría de Salud de Hidalgo",
      //   "informacion_item_url": "../contenido/informacion/M.O. SESA act. 30 agos 19.pdf",
      // },
      // {
      //   "informacion_item_nombre": "Manual de Procedimientos de la Secretaría de Salud de Hidalgo",
      //   "informacion_item_url": "../contenido/informacion/MANUAL DE PROCEDIMIENTOS SESA.pdf",
      // },
    ]
  },
  {
    "informacion_grupo":"Dirección de Investigación en Salud",
    "informacion_array":[
      {
        "informacion_item_nombre": "Gaceta Hidalguense",
        "informacion_item_url": "Gaceta/Gaceta",
      },
      {
        "informacion_item_nombre": "Boletín de Vigilancia Científica",
        "informacion_item_url": "Gaceta/Gaceta",
      },
    ]
  },
  {
    "informacion_grupo":"Otros",
    "informacion_array":[
      {  
        "informacion_item_nombre": "Conoce tu Secretaría",
        "informacion_item_url": "Conoce",
      },
      {  
        "informacion_item_nombre": "Directorio de Jurisdicciones Sanitarias",
        "informacion_item_url": "Jurisdicciones",
      },
      {
        "informacion_item_nombre": "Manual para la Validación de Espacios Promotores de Alimentación Correcta y Actividad Física",
        "informacion_item_url": "../contenido/informacion/Manual Espacio Promotor de la Alimentación Correcta y la AF_REV 210319.pdf",
      },
    ]
  }

  // {
  //   informacion_item_nombre: "Publicaciones",
  //   informacion_item_url: "Publicaciones",
  // },
  
  // {
  //   informacion_item_nombre: "Atlas",
  //   informacion_item_url: "http://atlas.ssh.gob.mx",
  // },
  
];